/* eslint-disable no-restricted-globals */
// @ts-nocheck
import React, {useState, useMemo} from "react";
import {Controller, useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

import {useClickOutside} from "hooks";
import {CloseButtonModal} from "components/CloseButton";
import {useStores} from "hooks/useStores";
import {INVALIDATION_TIP, REGEX} from "../../const/validation";
import {TextInput} from "../TextInput";

import styles from "./styles/lkCreateEmail.module.scss";

const firstStepSchema = yup.object().shape({
  email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_EMAIL,
      INVALIDATION_TIP.INCORRECT_EMAIL,
    )
});

const secondStepSchema = yup.object().shape({
  email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_EMAIL,
      INVALIDATION_TIP.INCORRECT_EMAIL,
    ),
  code: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{6}/, INVALIDATION_TIP.INCORRECT_CODE_LENGTH),
});

const CREAT_EMAIL_STEPS = {
  GET_CODE: 1,
  CHECK_CODE: 2
};

export const handleChangeMaxLength = (e, maxLength) => {
  e.target.value = e.target.value.slice(0, maxLength);
};

export default function LkCreateEmailNew(props) {
  const [step, setStep] = useState(1);

  const [emailChanged, setEmailChanged] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [response, setResponse] = useState({});

  const {api, userStore} = useStores();

  const containerRef = useClickOutside(() => {
    closeChangeEmail();
  })

  const formSchema = useMemo(
    () => (step === 1 ? firstStepSchema : secondStepSchema),
    [step],
  );

  const {
    register,
    handleSubmit,
    formState: {errors, isValid},
    reset,
    setError,
    clearErrors,
    control,
  } = useForm({
    mode: "all",
    resolver: yupResolver(formSchema),
  });

  const getCode = (data) => {
    const reqObj = {...data, email: data.email};

    reset({code: ''}, {keepValues: true});
    api.user.postChangeMailConfirm(reqObj)
      .then((response) => {
        setConfirmEmail(true);
        handleGetCode();
      })
      .catch((error) => {
        setError('email', {
          message: error.response.data.error,
        });
      });
  }

  const onSubmit = (data) => {
    switch (step) {
      case CREAT_EMAIL_STEPS.GET_CODE:
        getCode(data);
        break;
      case CREAT_EMAIL_STEPS.CHECK_CODE:
        api.user.postChangeMailConfirm({
          email: data.email,
          confirm_code: data.code,
        })
          .then((response) => {
            if (response.code_valid === false) {
              setError('code', {
                message: INVALIDATION_TIP.INCORRECT_CODE_SMS,
              });
              return;
            }
            setResponse(response);
            setEmailChanged(false);
            userStore.getUser();
            goToLk();
          })
          .catch((error) => {
            setError('code', {
              message: INVALIDATION_TIP.INCORRECT_CODE_SMS,
            });
          });
        break;
      default:
        break;
    }
  };

  const handleGetCode = () => {
    setStep(2);
    clearErrors();
  };

  const closeChangeEmail = () => {
    document.querySelector("#createEmailPopup").style.display = "none";
    reset({
      email: "",
    });
    setStep(1);
  };

  const goToLk = () => {
    closeChangeEmail();
    setEmailChanged(false);
  };

  return (
    <div className={ styles.create_email } id='createEmailPopup'>
      <div className={ styles.create_email__container } ref={containerRef}>
        <CloseButtonModal handleClose={closeChangeEmail}/>
        <div className={ styles.create_email__container_main } id='containerMain'>
          <h1 className={ styles.create_email__title }>Добавление email</h1>
          <form className={styles.create_email_form} onSubmit={handleSubmit(onSubmit)}>
            <div className={ styles.create_email__form_items }>
              <lable className={ styles.create_email__lable } htmlFor='email'>
                Email
              </lable>
              <input
                autoFocus
                {...register("email")}
                id='email'
                name='email'
                type='email'
                disabled={step !== 1}
                className={styles.create_email__input_mail}
              />
              {errors.email && (
                <p className={ styles.create_form__error_phone }>{errors.email?.message}</p>
              )}
            </div>

            {step === 1 && (
              <button
                className={ styles.create_email_button }
                text="Получить код на Email"
                type="submit"
                disabled={!isValid}
              >Получить код на Email</button>
            )}

            {step === 2 && (
              <div className={ styles.create_email__form_items }>
                <lable className={ styles.create_email__lable } htmlFor='code'>
                  Код из e-mail
                </lable>
                <Controller
                  render={({field: {onChange, value}}) => (
                    <TextInput
                      className={styles.form__input}
                      type="number"
                      controls={false}
                      onChange={(event) => {
                        handleChangeMaxLength(event, 6)
                        onChange(event)
                      }}
                      step={1}
                    />
                  )}
                  name="code"
                  control={control}
                  step={1}
                />
                {errors.code && (<span className={ styles.create_form__error }>
                  {errors.code?.message}
                </span>
                )}
                <button
                  className={ styles.create_email_button }
                  text="Сохранить"
                  type="submit"
                  disabled={!isValid}
                >
                  Сохранить
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
